module.exports = __webpack_public_path__ + "img/252.invoice_submitted.8baa03c5.svg";